export const primarycolor='#33A8FF'
